import { Button, Input, Spin, Tag } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { FiEdit, FiEye, FiTrash } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import { api } from "@/api";
import appConfig from "@/config/appConfig";
import { DataTable } from "@/components";
import { userRole } from "@/constant";
import { flare } from "@flareapp/js";

const SiteLocationsList = () => {
  const { userDetails, business } = useSelector((state) => state?.user);

  const [siteLocations, setSiteLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [total, setTotal] = useState();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const getSiteLocations = async () => {
    setIsLoading(true);
    try {
      const { data, total } = await api.get("/site-location", {
        params: { business, searchText, unknown: true, page, limit },
      });
      if (data) {
        setSiteLocations(
          (data || []).map((item, idx) => {
            item.sl = (page - 1) * limit + idx + 1;
            return item;
          }),
        );
        setTotal(total);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site locations list", error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    document.title = appConfig.name + " - All Site Locations";
    getSiteLocations();
  }, [business, searchText, limit, page]);

  const LimitedTags = ({ list, limit = 3 }) => (
    <>
      {Array.isArray(list)
        ? list.map((item, idx) =>
            idx < limit ? (
              <Tag key={idx} className="d-block my-1">
                {" "}
                {item.name}{" "}
              </Tag>
            ) : (
              ""
            ),
          )
        : ""}
      {list?.length > limit ? <Tag className="d-inline-block my-1"> + {list?.length - limit} ... </Tag> : ""}
    </>
  );

  LimitedTags.propTypes = {
    list: PropTypes.array,
    limit: PropTypes.number,
  };

  const columns = [
    {
      title: "No",
      render: (_, { sl }) => sl,
      width: "60px",
    },
    {
      title: "Site Name",
      render: (_, row) => row.name,
    },
    {
      title: "Business",
      render: (_, row) =>
        row.businesses?.length ? (
          <>
            {row.businesses[0]?.name} ({row.businesses[0]?.id})
          </>
        ) : (
          <></>
        ),
    },
    {
      title: "Business Admin",
      render: (_, row) => <LimitedTags list={row?.businessAdmin} />,
    },
    {
      title: "Site Admin",
      render: (_, row) => row?.adminCount ?? (Array.isArray(row?.admin) ? row.admin.length : 0),
      align: "center",
    },
    {
      title: "Installer",
      render: (_, row) => row?.installerCount ?? (Array.isArray(row?.installer) ? row.installer.length : 0),
      align: "center",
    },
    {
      title: "Devices",
      render: (_, row) => row?.deviceCount || 0,
      align: "center",
      // center: true,
    },
    {
      title: "Action",
      render: (_, row) => (
        <div>
          {(() => {
            switch (userDetails.role) {
              case "superAdmin":
                return (
                  <div className="actions">
                    <Link to={`/site-locations/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye title="View" />
                    </Link>
                    <Link to={`/site-locations/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit title="Edit" />
                    </Link>
                    {/* <Link
                      to={`/site-locations/document/` + row._id}
                      className="btn btn-warning me-1"
                    >
                      <FiPaperclip title="Documents" />
                    </Link> */}
                    <button className="btn btn-danger" onClick={() => deleteSiteLocation(row._id)}>
                      <FiTrash title="Delete" />
                    </button>
                  </div>
                );
              case "businessAdmin":
                return (
                  <div className="actions">
                    <Link to={`/site-locations/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye title="View" />
                    </Link>
                    <Link to={`/site-locations/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit title="Edit" />
                    </Link>
                    {/* <Link
                      to={`/site-locations/document/` + row._id}
                      className="btn btn-warning me-1"
                    >
                      <FiPaperclip title="Documents" />
                    </Link> */}
                    <button className="btn btn-danger" onClick={() => deleteSiteLocation(row._id)}>
                      <FiTrash title="Delete" />
                    </button>
                  </div>
                );
              case "installer":
                return (
                  <div className="actions">
                    <Link to={`/site-locations/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye title="View" />
                    </Link>
                  </div>
                );
              case "admin":
                return (
                  <div className="actions">
                    <Link to={`/site-locations/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye title="View" />
                    </Link>
                    <Link to={`/site-locations/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit title="Edit" />
                    </Link>
                    {/* <Link
                      to={`/site-document/` + row._id}
                      className="btn btn-warning me-1"
                    >
                      <FiPaperclip title="Documents" />
                    </Link> */}
                    {/* <button className="btn btn-danger" onClick={() => deleteSiteLocation(row._id)}>
                      <FiTrash title="Delete" />
                    </button> */}
                  </div>
                );
              case "user":
                return (
                  <div className="actions">
                    <Link to={`/site-locations/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye title="View" />
                    </Link>
                  </div>
                );
              case "public":
                return (
                  <div className="actions">
                    <Link to={`/site-locations/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye title="View" />
                    </Link>
                  </div>
                );
              default:
                return;
            }
          })()}
        </div>
      ),
      align: "center",
      // grow: 2,
      width: 180,
      // center: "yes",
    },
  ];

  const deleteSiteLocation = async (siteLocationId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this site location?",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`/site-location/` + siteLocationId, {
            withCredentials: true,
          })
          .then((res) => {
            getSiteLocations(userDetails);
            Swal.fire({
              title: "Done!",
              text: res?.data?.message || "Site location Successfully Deleted",
              icon: "success",
              timer: 2000,
              button: false,
            });
          })
          .catch((error) => {
            Swal.fire({
              title: "",
              text: error?.response?.data?.message || "Error happened",
              icon: "error",
              timer: 2000,
              button: false,
            });
          });
      }
    });
  };

  return (
    <div className="card p-3 m-md-3">
      {/* <h3>All Site Locations</h3> */}
      <div className="d-flex flex-column flex-md-row g-3 align-items-md-center mb-3 justify-content-between">
        <div>
          <label className="az-content-label">Manage Site Location</label>
          <span className="d-block py-2">All Site Locations</span>
        </div>
        {![userRole.admin, userRole.installer, userRole.user, userRole.public].includes(userDetails?.role) && (
          <div className="ms-md-auto p-0">
            <Link to="/site-locations/create">
              <Button icon={<FaPlus />} type="primary">
                {" "}
                Add Site Location{" "}
              </Button>
            </Link>
          </div>
        )}
      </div>

      <hr className="mt-0" />
      <div className="row mb-2">
        <div className="col-md-10"></div>
        <div className="col-md-2">
          <Input
            type="search"
            size="large"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
            placeholder="Search"
            // className="me-2"
            aria-label="Search"
          />
        </div>
      </div>
      <Spin spinning={isLoading}>
        <DataTable
          dataSource={siteLocations}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={{
            defaultPageSize: 10,
            current: page,
            total,
            showSizeChanger: true,
            onShowSizeChange: (_, pageSize) => {
              setLimit(pageSize);
            },
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
            pageSizeOptions: [10, 20, 50],
            responsive: true,
          }}
          onChange={(pagination) => {
            setPage(pagination.current);
          }}
        />
      </Spin>
    </div>
  );
};

export default SiteLocationsList;
